import React from "react";
import SkeletonLoader from "components/skeletonLoader";
import { useTranslation } from "react-i18next";
import { EventPickProvider } from "context/eventPickContext";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import EventCard from "./eventCard";
import EventCardLms from "./eventCardLms";

import { SliderProvider } from "context/sliderContext";

const RoundEvents = () => {
  const { t } = useTranslation();

  const {
    state: { roundEvents, isLoading, currentRound },
  } = useRound();

  const {
    state: { leagueInfo },
  } = useLeague();

  let roundStarted =
    new Date(currentRound?.deadline?.seconds * 1000) < new Date() ||
    currentRound?.settled;

  const eventList = roundEvents
    .sort((a, b) => {
      return (
        new Date(a?.startTime.seconds * 1000) -
        new Date(b?.startTime.seconds * 1000)
      );
    })
    .map((ev, id) => (
      <EventPickProvider key={ev.id}>
        {leagueInfo?.gameType == 1 && leagueInfo?.gameRule == 2 ? (
          <EventCardLms eventInfo={ev} id={ev.id} />
        ) : (
          <EventCard eventInfo={ev} id={ev.id} />
        )}
      </EventPickProvider>
    ));

  return (
    <div>
      <div className="w-full mx-auto">
        <>
          <div className="  rounded-lg">
            <div className="w-full mb-4">
              <div className="flex mb-1 w-full">
                {((leagueInfo?.scoreRule === 5 && !roundStarted) ||
                  leagueInfo?.scoreRule !== 5) && (
                  <div className="flex px-2  w-full text-textPrimary">
                    <div className="block uppercase tracking-wide text-xs text-textPrimary">
                      {t("tournament.events.title")}
                    </div>
                  </div>
                )}
                {(leagueInfo?.gameRule == 0 || leagueInfo?.gameRule == 4) && (
                  <div className="flex w-fit rounded-r-md pl-0 xs:pl-2 pr-2 xs:pr-2 justify-end space-x-2 text-xs text-textPrimary items-end">
                    <div className="flex w-10 justify-center items-end">
                      {t("tournament.events.home")}
                    </div>
                    <div className="flex w-10 justify-center">
                      {" "}
                      {t("tournament.events.draw")}
                    </div>
                    <div className="flex w-10 justify-center">
                      {" "}
                      {t("tournament.events.away")}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-col space-y-3">
                {isLoading ? (
                  <SkeletonLoader type={"eventCard2"} amount={3} />
                ) : (
                  <SliderProvider>{eventList}</SliderProvider>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default RoundEvents;
